var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSystemSaveError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 156.634,
    height: 127.73,
    viewBox: "0 0 156.634 127.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_582",
    "data-name": "Rectangle 582",
    width: 79.096,
    height: 68.316,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "System_Save_Error",
    "data-name": "System Save Error",
    transform: "translate(70.538 59.412)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37037",
    "data-name": "Path 37037",
    d: "M-172.63,371.871V490.278h71.665V371.871Zm29.786,87.956h-16v-16h16Zm0-27.553h-16v-16h16Zm0-27.552h-16v-16h16Zm27.66,55.105h-16v-16h16Zm0-27.553h-16v-16h16Zm0-27.552h-16v-16h16Zm75.641,22.931V490.7h-16.7v-33.25H-81.186V490.7h-16.7V427.652Zm0-11.609H-97.891v8.783h58.348Z",
    transform: "translate(102.092 -431.283)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7291",
    "data-name": "Group 7291",
    transform: "translate(7 0.002)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6806",
    "data-name": "Path 6806",
    d: "M41.893,1.347l36.826,62.88a2.718,2.718,0,0,1-2.345,4.091H2.722A2.718,2.718,0,0,1,.377,64.227L37.2,1.347a2.718,2.718,0,0,1,4.691,0",
    transform: "translate(0 -0.002)",
    fill: "#eed202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6807",
    "data-name": "Path 6807",
    d: "M550.944,667.528a2.961,2.961,0,1,1-2.961-2.961,2.961,2.961,0,0,1,2.961,2.961",
    transform: "translate(-508.526 -615.422)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6808",
    "data-name": "Path 6808",
    d: "M527.228,302.387h-.044a1.972,1.972,0,0,1-1.958-1.738L522.8,280.325a1.972,1.972,0,0,1,1.958-2.206h4.949a1.972,1.972,0,0,1,1.958,2.211l-2.48,20.324a1.972,1.972,0,0,1-1.957,1.733",
    transform: "translate(-487.78 -254.851)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemSaveError);
export default __webpack_public_path__ + "static/media/System Save Error.6433c438dcada684b8e6a0053719d942.svg";
export { ForwardRef as ReactComponent };